import React from 'react';
import NameInputContainer from 'components/BoxNameInputContainer';

export default React.memo(({item, handleChange}) => {
  const inputProps = (property) => ({
    value: item[property],
    inputClass: 'form-control',
    handleChange: (event) => handleChange(property, event.target.value),
  });
  return (
    <NameInputContainer
      type="text"
      firstName={inputProps('firstName')}
      lastName={inputProps('lastName')}
      className="dashed custom-input-container"
      placeholder="NAME"
    />
  );
});
